<script lang="ts">
  import LetterOrderTag from "../../../../../../../../../../../_shared/_modules/letter-order-tag"
  import {
    buildLetterOrderTag,
    type LetterOrderReference,
  } from "../../../../../../../../../../../_shared/_logic/letter-order-tag"
  let { row }: { row: LetterOrderReference } = $props()
  const tag = $derived(buildLetterOrderTag(row))
</script>

<LetterOrderTag {tag} />
